import axios from 'axios';
import * as types from '../constants/ActionTypes';
import {
  insertAdImport,
  deleteAdImport,
  insertPresentationImport
} from '../services/AdServiceManager';

import { getIdToken } from '../services/ServiceManager';

export const fetchAdHtml = (url, fileName) => async (dispatch) => {
  dispatch({ type: types.AD_IMPORT_FETCH_HTML });
  try {
    getIdToken().then(async (result) => {
      if (!result || result === '') {
        throw new Error('AlexiaAuth token cannot be generated.');
      }

      const headers = {
        AlexiaAuth: result
      };

      const response = await axios(`${url}?fileName=${fileName}`, {
        headers
      });
      const urlIframe =
        response.data && response.data.url ? response.data.url : null;
      dispatch({ type: types.AD_IMPORT_FETCH_HTML_SUCCESS, url: urlIframe });
    });
  } catch (e) {
    dispatch({ type: types.AD_IMPORT_FETCH_HTML_ERROR, error: e.response });
  }
};

export const newAdImport = (data) => async (dispatch) => {
  dispatch({ type: types.AD_IMPORT_INSERT });
  try {
    const response = await insertAdImport({
      ...data,
      product: data.product.toString()
    });
    dispatch({ type: types.AD_IMPORT_INSERT_SUCCESS, id: response.id });
  } catch (e) {
    dispatch({ type: types.AD_IMPORT_INSERT_ERROR, error: e.response });
  }
};

export const removeAdImport = (id) => async (dispatch) => {
  dispatch({ type: types.AD_IMPORT_INSERT });
  try {
    const response = await deleteAdImport(id);
    dispatch({ type: types.AD_IMPORT_INSERT_SUCCESS, id: response.id });
  } catch (e) {
    dispatch({ type: types.AD_IMPORT_INSERT_ERROR, error: e.response });
  }
};

export const newPresentationImport = (data) => async (dispatch) => {
  dispatch({ type: types.AD_IMPORT_INSERT });
  try {
    const response = await insertPresentationImport(data);
    dispatch({ type: types.AD_IMPORT_INSERT_SUCCESS, id: response.id });
  } catch (e) {
    dispatch({ type: types.AD_IMPORT_INSERT_ERROR, error: e.response });
  }
};

export function fetchPresentationImport(url) {
  return (dispatch) => {
    fetch(url) // eslint-disable-line no-undef
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch({
          type: types.AD_IMPORT_FETCH_PRESENTATION_SUCCESS,
          data: json
        });
      })
      .catch((err) => {
        dispatch({
          type: types.AD_IMPORT_FETCH_PRESENTATION_ERROR,
          error: err
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/AdImportActions.js